import { LandingPageContent } from "./LandingPageContent";

export function LandingPage() {
  return <LandingPageContent />;
}
